import React from 'react';

const Address = ({ locationAddress }) => {
  return (<p className="address">Endereço: <b>{locationAddress}</b></p>);
};

export default Address;
